import React from "react";
import { Route, Redirect } from "react-router-dom";
import DashboardComponent from "./modules/dashboard/DashboardComponent";
import ChartsComponent from "./modules/dashboard/charts/ChartsComponent";
import SettingsComponent from "./modules/administration/settings/SettingsComponent";
import {} from "./api/HttpClient";
import {} from "./properties/Locale";
import {} from "./api/HttpClient";
import {} from "./properties/Locale";
import styles from "./assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
import { routes } from "./properties/routes";
import bgImage from "./assets/img/progress.jpg";
import logo from "./assets/img/grb.png";
import Sidebar from "./common/components/Sidebar";
import Header from "./common/components/Header";
import PerfectScrollbar from "perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { LinearProgress } from "@material-ui/core";
import { COMMON_ACTIONS } from "./common/actions/CommonActions";
import Snackbar from "./common/components/Snackbar/Snackbar.js";
import UsersComponent from "./modules/administration/users/UsersComponent";
import PrivilegesComponent from "./modules/administration/privileges/PrivilegesComponent";
import GroupsComponent from "./modules/administration/groups/GroupsComponent";
import UserDetailsComponent from "./modules/administration/users/UserDetailsComponent";
import UserEditComponent from "./modules/administration/users/UserEditComponent";
import UserDeleteComponent from "./modules/administration/users/UserDeleteComponent";
import GroupDetailsComponent from "./modules/administration/groups/GroupDetailsComponent";
import GroupEditComponent from "./modules/administration/groups/GroupEditComponent";
import GroupCreateComponent from "./modules/administration/groups/GroupCreateComponent";
import GroupDeleteComponent from "./modules/administration/groups/GroupsDeleteComponent";
import UserCreateComponent from "./modules/administration/users/UserCreateComponent";
import AuditLogComponent from "./modules/administration/audit/AuditLogComponent";
import MailLogComponent from "./modules/administration/mail/MailLogComponent";
import MailTemplateComponent from "./modules/administration/mail/MailTemplateComponent";
import UserProfileComponent from "./modules/profile/UserProfileComponent";
import { UsersRepository } from "./modules/administration/users/UsersRepository";
import MunicipalitiesComponent from "./modules/configuration/municipalities/MunicipalitiesComponent";
import MunicipalityCreateComponent from "./modules/configuration/municipalities/MunicipalityCreateComponent";
import MunicipalityEditComponent from "./modules/configuration/municipalities/MunicipalityEditComponent";
import MunicipalityDetailsComponent from "./modules/configuration/municipalities/MunicipalityDetailsComponent";
import MunicipalityDeleteComponent from "./modules/configuration/municipalities/MunicipalityDeleteComponent";
import SchoolsComponent from "./modules/configuration/schools/SchoolsComponent";
import SchoolCreateComponent from "./modules/configuration/schools/SchoolCreateComponent";
import SchoolDetailsComponent from "./modules/configuration/schools/SchoolDetailsComponent";
import SchoolEditComponent from "./modules/configuration/schools/SchoolEditComponent";
import SchoolDeleteComponent from "./modules/configuration/schools/SchoolDeleteComponent";
import VacancyConfigComponent from "./modules/configuration/vacancyApplicationConfig/VacancyConfigComponent";
import { AuthRepository } from "./auth/AuthRepository";
import { SETTINGS } from "./properties/ApiProps";
import FormBuilderComponent from "./modules/form-builder/FormBuilderComponent";
import VacancyApp from "./modules/vacancyApplication/VacancyApp";
import VacancyComponent from "./modules/vacancy/VacancyComponent";
import VacancyCreateComponent from "./modules/vacancy/VacancyCreateComponent";
import VacancyEditComponent from "./modules/vacancy/VacancyEditComponent";
import VacancyDetailsComponent from "./modules/vacancy/VacancyDetailsComponent";
import TrainingOrganizerCreateComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingOrganizer/TrainingOrganizerCreateComponent";
import TrainingOrganizerDetailsComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingOrganizer/TrainingOrganizerDetailsComponent";
import TrainingOrganizerEditComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingOrganizer/TrainingOrganizerEditComponent";
import TrainingOrganizerDeleteComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingOrganizer/TrainingOrganizerDeleteComponent";
import TrainingRoleCreateComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingRole/TrainingRoleCreateComponent";
import TrainingRoleDetailsComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingRole/TrainingRoleDetailsComponent";
import TrainingRoleEditComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingRole/TrainingRoleEditComponent";
import TrainingRoleDeleteComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingRole/TrainingRoleDeleteComponent";
import TrainingHourRangeCreateComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingHourRange/TrainingHourRangeCreateComponent";
import TrainingHourRangeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingHourRange/TrainingHourRangeDetailsComponent";
import TrainingHourRangeEditComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingHourRange/TrainingHourRangeEditComponent";
import TrainingHourRangeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/training/trainingHourRange/TrainingHourRangeDeleteComponent";
import ProfessionalEventTypeCreateComponent from "./modules/configuration/vacancyApplicationConfig//professionalEvent/professionalEventType/ProfessionalEventTypeCreateComponent";
import ProfessionalEventTypeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventType/ProfessionalEventTypeDetailsComponent";
import ProfessionalEventTypeEditComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventType/ProfessionalEventTypeEditComponent";
import ProfessionalEventTypeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventType/ProfessionalEventTypeDeleteComponent";
import ProfessionalEventRoleCreateComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventRole/ProfessionalEventRoleCreateComponent";
import ProfessionalEventRoleDetailsComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventRole/ProfessionalEventRoleDetailsComponent";
import ProfessionalEventRoleEditComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventRole/ProfessionalEventRoleEditComponent";
import ProfessionalEventRoleDeleteComponent from "./modules/configuration/vacancyApplicationConfig/professionalEvent/professionalEventRole/ProfessionalEventRoleDeleteComponent";
import AuthorshipTypeCreateComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipType/AuthorshipTypeCreateComponent";
import AuthorshipTypeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipType/AuthorshipTypeDetailsComponent";
import AuthorshipTypeEditComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipType/AuthorshipTypeEditComponent";
import AuthorshipTypeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipType/AuthorshipTypeDeleteComponent";
import AuthorshipRoleCreateComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipRole/AuthorshipRoleCreateComponent";
import AuthorshipRoleDetailsComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipRole/AuthorshipRoleDetailsComponent";
import AuthorshipRoleEditComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipRole/AuthorshipRoleEditComponent";
import AuthorshipRoleDeleteComponent from "./modules/configuration/vacancyApplicationConfig/authorship/authorshipRole/AuthorshipRoleDeleteComponent";
import EducationalTypeCreateComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalType/EducationalTypeCreateComponent";
import EducationalTypeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalType/EducationalTypeDetailsComponent";
import EducationalTypeEditComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalType/EducationalTypeEditComponent";
import EducationalTypeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalType/EducationalTypeDeleteComponent";
import EducationalRoleCreateComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalRole/EducationalRoleCreateComponent";
import EducationalRoleDetailsComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalRole/EducationalRoleDetailsComponent";
import EducationalRoleEditComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalRole/EducationalRoleEditComponent";
import EducationalRoleDeleteComponent from "./modules/configuration/vacancyApplicationConfig/educationalActivity/educationalRole/EducationalRoleDeleteComponent";
import AwardRecognitionCreateComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardRecognition/AwardRecognitionCreateComponent";
import AwardRecognitionDetailsComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardRecognition/AwardRecognitionDetailsComponent";
import AwardRecognitionEditComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardRecognition/AwardRecognitionEditComponent";
import AwardRecognitionDeleteComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardRecognition/AwardRecognitionDeleteComponent";
import AwardLevelCreateComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardLevel/AwardLevelCreateComponent";
import AwardLevelDetailsComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardLevel/AwardLevelDetailsComponent";
import AwardLevelEditComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardLevel/AwardLevelEditComponent";
import AwardLevelDeleteComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardLevel/AwardLevelDeleteComponent";
import AwardTypeCreateComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardType/AwardTypeCreateComponent";
import AwardTypeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardType/AwardTypeDetailsComponent";
import AwardTypeEditComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardType/AwardTypeEditComponent";
import AwardTypeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/awardsAndRecognition/awardType/AwardTypeDeleteComponent";
import OpenVacanciesComponent from "./modules/vacancy/OpenVacanciesComponent";
import MyVacancyAppsComponent from "./modules/vacancyApplication/MyVacancyAppsComponent";
import VacancyAppEvaluation from "./modules/vacancyApplication/VacancyAppEvaluation";
import GradingSchemaComponent from "./modules/configuration/gradingSchema/GradingSchemaComponent";
import GradingSchemaCreateComponent from "./modules/configuration/gradingSchema/GradingSchemaCreateComponent";
import GradingSchemaDetailsComponent from "./modules/configuration/gradingSchema/GradingSchemaDetailsComponent";
import GradingSchemaEditComponent from "./modules/configuration/gradingSchema/GradingSchemaEditComponent";
import GradingSchemaDeleteComponent from "./modules/configuration/gradingSchema/GradingSchemaDeleteComponent";
import BureauGradingComponent from "./modules/vacancyApplication/grading/BureauGradingComponent";
import EducationalCenterGradingComponent from "./modules/vacancyApplication/grading/EducationalCenterGradingComponent";
import SchoolGradingComponent from "./modules/vacancyApplication/grading/SchoolGradingComponent";
import BureauGradingDashboardComponent from "./modules/vacancyApplication/grading/BureauGradingDashboardComponent";
import EducationalCenterGradingDashboardComponent from "./modules/vacancyApplication/grading/EducationalCenterGradingDashboardComponent";
import SchoolGradingDashboardComponent from "./modules/vacancyApplication/grading/SchoolGradingDashboardComponent";
import ProfessionalTitleTypeCreateComponent from "./modules/configuration/vacancyApplicationConfig//professionalTitle/professionalTitleType/ProfessionalTitleTypeCreateComponent";
import ProfessionalTitleTypeDetailsComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleType/ProfessionalTitleTypeDetailsComponent";
import ProfessionalTitleTypeEditComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleType/ProfessionalTitleTypeEditComponent";
import ProfessionalTitleTypeDeleteComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleType/ProfessionalTitleTypeDeleteComponent";
import ProfessionalTitleAreaCreateComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleArea/ProfessionalTitleAreaCreateComponent";
import ProfessionalTitleAreaDetailsComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleArea/ProfessionalTitleAreaDetailsComponent";
import ProfessionalTitleAreaEditComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleArea/ProfessionalTitleAreaEditComponent";
import ProfessionalTitleAreaDeleteComponent from "./modules/configuration/vacancyApplicationConfig/professionalTitle/professionalTitleArea/ProfessionalTitleAreaDeleteComponent";
import CommissionGradingComponent from "./modules/vacancyApplication/grading/CommissionGradingComponent";
import { createBrowserHistory } from "history";
import CommisionPreviewComponent from "./modules/vacancyApplication/preview/CommisionPreviewComponent";
import VacancyAppPreview from "./modules/vacancyApplication/VacancyAppPreview";
import VacancyAllotmentComponent from "./modules/vacancyApplication/allotment/VacancyAllotmentComponent";
import VacancyTransferComponent from "./modules/vacancyApplication/transfer/VacancyTransferComponent";
import VacancyAdditionalDataRequired from "./modules/vacancyApplication/additionalDataRequired/VacancyAdditionalDataRequired.js";
import VacancyApplicationDocumentVerification from "./modules/vacancyApplication/documentVerification/VacancyApplicationDocumentVerification.js";
import RankListComponent from "./modules/vacancyApplication/grading/RankListComponent.js";

let ps;
const useStyles = makeStyles(styles);

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

export default function App() {
  const classes = useStyles();
  const globalState = useSelector((state) => state);
  const dispatch = useDispatch();
  const mainPanel = React.createRef();
  const counter = useSelector((state) => state);

  const resizeFunction = () => {
    dispatch({
      type: COMMON_ACTIONS.MOBILE_SCREEN,
      payload: {
        mobileOpen: false,
      },
    });
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel, resizeFunction]);

  React.useEffect(() => {
    if (
      localStorage.getItem("accessToken") &&
      localStorage.getItem("currentUser")
    ) {
      UsersRepository.fetchCurrentUser().then(
        (res) => {},
        (err) => {
          AuthRepository.logout();
        }
      );
    }
  }, []);

  const handleClose = () => {
    if (globalState.open) {
      dispatch({
        type: COMMON_ACTIONS.CLEAR_NOTIFICATIONS,
        payload: null,
      });
    }
  };

  return (
    <div className={classes.wrapper}>
      <div style={{ minHeight: "4px" }}>
        {globalState.loading && <LinearProgress color="secondary" />}
      </div>
      <Sidebar
        routes={routes}
        logoText={SETTINGS.APP_NAME}
        logo={logo}
        image={bgImage}
        handleDrawerToggle={globalState.mobileOpen}
        open={globalState.mobileOpen}
        color={"blue"}
      />

      {globalState.open && (
        <Snackbar
          place="br"
          icon={globalState.variant}
          color={globalState.variant}
          message={globalState.message}
          open={true}
          closeNotification={handleClose}
          close
        />
      )}

      <div className={classes.mainPanel}>
        <Header />
        <div className={classes.content} ref={mainPanel}>
          <div className={classes.container}>
            <Route>
              {/* ======================= DEFAULT REDIRECT ROUTE ======================= */}
              <Route
                exact
                path="/"
                render={() => <Redirect to="/app/dashboard" />}
              />

              {/* ======================= DASHBOARD ROUTES ======================= */}
              <Route
                path="/app/dashboard"
                exact
                component={DashboardComponent}
              />
              <Route path="/app/charts" exact component={ChartsComponent} />

              {/* ======================= SETTINGS ROUTES ======================= */}
              <Route
                path="/app/admin/settings"
                exact
                component={SettingsComponent}
              />

              {/* ======================= USERS ROUTES ======================= */}
              <Route path="/app/admin/users" component={UsersComponent} />
              <Route
                path="/app/admin/users/create"
                component={UserCreateComponent}
              />
              <Route
                path="/app/admin/users/details/:userId"
                component={UserDetailsComponent}
              />
              <Route
                path="/app/admin/users/edit/:userId"
                component={UserEditComponent}
              />
              <Route
                path="/app/admin/users/delete/:userId"
                component={UserDeleteComponent}
              />

              {/* ======================= GROUPS ROUTES ======================= */}
              <Route path="/app/admin/groups" component={GroupsComponent} />
              <Route
                path="/app/admin/privileges"
                exact
                component={PrivilegesComponent}
              />
              <Route
                path="/app/admin/groups/create"
                component={GroupCreateComponent}
              />
              <Route
                path="/app/admin/groups/details/:groupId"
                component={GroupDetailsComponent}
              />
              <Route
                path="/app/admin/groups/edit/:groupId"
                component={GroupEditComponent}
              />
              <Route
                path="/app/admin/groups/delete/:groupId"
                component={GroupDeleteComponent}
              />
              {/* ======================= AUDIT LOG ROUTES ======================= */}
              <Route path="/app/admin/auditLog" component={AuditLogComponent} />
              {/* ======================= MAIL ROUTE ======================= */}
              <Route path="/app/admin/mailLog" component={MailLogComponent} />
              <Route
                path="/app/admin/mailTemplate"
                component={MailTemplateComponent}
              />
              {/* ======================= USER PROFILE ROUTE ======================= */}
              <Route path="/app/profile" component={UserProfileComponent} />

              {/* ======================= FORM BUILDER ROUTE ======================= */}
              <Route path="/app/formBuilder" component={FormBuilderComponent} />
              {/* ======================= MUNICIPALITIES ROUTE ======================= */}
              <Route
                path="/app/configuration/municipalities"
                component={MunicipalitiesComponent}
              />
              <Route
                path="/app/configuration/municipalities/create"
                component={MunicipalityCreateComponent}
              />
              <Route
                path="/app/configuration/municipalities/edit/:municipalityId"
                component={MunicipalityEditComponent}
              />
              <Route
                path="/app/configuration/municipalities/details/:municipalityId"
                component={MunicipalityDetailsComponent}
              />
              <Route
                path="/app/configuration/municipalities/delete/:municipalityId"
                component={MunicipalityDeleteComponent}
              />
              {/* ======================= SCHOOLS ROUTE ======================= */}
              <Route
                path="/app/configuration/schools"
                component={SchoolsComponent}
              />
              <Route
                path="/app/configuration/schools/create"
                component={SchoolCreateComponent}
              />

              <Route
                path="/app/configuration/schools/:schoolId/details"
                component={SchoolDetailsComponent}
              />

              <Route
                path="/app/configuration/schools/:schoolId/edit"
                component={SchoolEditComponent}
              />

              <Route
                path="/app/configuration/schools/:schoolId/delete"
                component={SchoolDeleteComponent}
              />
              {/* ===================== VACANCY APP ROUTE ========================= */}
              <Route
                path="/app/vacancy-application/:vacancyId/:vacancyApplicationId"
                component={VacancyApp}
              />
              <Route
                path="/app/vacancy-evaluation/:vacancyId/:vacancyApplicationId"
                component={VacancyAppEvaluation}
              />

              <Route
                path="/app/open-vacancies"
                component={OpenVacanciesComponent}
              />
              <Route
                path="/app/my-vacancy-applications"
                component={MyVacancyAppsComponent}
              />
              <Route
                path="/app/commission-grading"
                component={CommissionGradingComponent}
              />
              <Route
                path="/app/commission-preview"
                component={CommisionPreviewComponent}
              />
              <Route path="/app/rank-list" component={RankListComponent} />
              <Route
                path="/app/vacancy-preview/:vacancyId/:vacancyApplicationId"
                component={VacancyAppPreview}
              />
              <Route
                path="/app/vacancy-allotment"
                component={VacancyAllotmentComponent}
              />
              <Route
                path="/app/vacancy-transfer"
                component={VacancyTransferComponent}
              />
              <Route
                path="/app/vacancy-add-data-req"
                component={VacancyAdditionalDataRequired}
              />
              {/* ===================== VACANCY ROUTE ========================= */}
              <Route path="/app/vacancy" component={VacancyComponent} />
              <Route
                path="/app/vacancy/create"
                component={VacancyCreateComponent}
              />
              <Route
                path="/app/vacancy/edit/:vacancyId"
                component={VacancyEditComponent}
              />
              <Route
                path="/app/vacancy/details/:vacancyId"
                component={VacancyDetailsComponent}
              />

              {/* ===================== GRADING SCHEMA ========================= */}
              <Route
                path="/app/configuration/gradingSchema"
                exact={true}
                component={GradingSchemaComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/create"
                component={GradingSchemaCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/details"
                component={GradingSchemaDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit"
                component={GradingSchemaEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/delete"
                component={GradingSchemaDeleteComponent}
              />

              {/* ===================== VACANCY CONFIGURATION ========================= */}
              <Route
                path="/app/configuration/vacancyConfig"
                component={VacancyConfigComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingOrganizer/create"
                component={TrainingOrganizerCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingOrganizer/:organizerId/details"
                component={TrainingOrganizerDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingOrganizer/:organizerId/edit"
                component={TrainingOrganizerEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingOrganizer/:organizerId/delete"
                component={TrainingOrganizerDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingRole/create"
                component={TrainingRoleCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingRole/:roleId/details"
                component={TrainingRoleDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingRole/:roleId/edit"
                component={TrainingRoleEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingRole/:roleId/delete/"
                component={TrainingRoleDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingHourRange/create"
                component={TrainingHourRangeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingHourRange/:hourRangeId/details"
                component={TrainingHourRangeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingHourRange/:hourRangeId/edit"
                component={TrainingHourRangeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/trainingHourRange/:hourRangeId/delete"
                component={TrainingHourRangeDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventType/create"
                component={ProfessionalEventTypeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventType/:eventTypeId/details"
                component={ProfessionalEventTypeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventType/:eventTypeId/edit"
                component={ProfessionalEventTypeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventType/:eventTypeId/delete"
                component={ProfessionalEventTypeDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventRole/create"
                component={ProfessionalEventRoleCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventRole/:eventRoleId/details"
                component={ProfessionalEventRoleDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventRole/:eventRoleId/edit"
                component={ProfessionalEventRoleEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalEventRole/:eventRoleId/delete"
                component={ProfessionalEventRoleDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipType/create"
                component={AuthorshipTypeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipType/:authorshipTypeId/details"
                component={AuthorshipTypeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipType/:authorshipTypeId/edit"
                component={AuthorshipTypeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipType/:authorshipTypeId/delete"
                component={AuthorshipTypeDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipRole/create"
                component={AuthorshipRoleCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipRole/:authorshipRoleId/details"
                component={AuthorshipRoleDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipRole/:authorshipRoleId/edit"
                component={AuthorshipRoleEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/authorshipRole/:authorshipRoleId/delete"
                component={AuthorshipRoleDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalType/create"
                component={EducationalTypeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalType/:educationalTypeId/details"
                component={EducationalTypeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalType/:educationalTypeId/edit"
                component={EducationalTypeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalType/:educationalTypeId/delete"
                component={EducationalTypeDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalRole/create"
                component={EducationalRoleCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalRole/:educationalRoleId/details"
                component={EducationalRoleDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalRole/:educationalRoleId/edit"
                component={EducationalRoleEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/educationalRole/:educationalRoleId/delete"
                component={EducationalRoleDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardRecognition/create"
                component={AwardRecognitionCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardRecognition/:awardRecognitionId/details"
                component={AwardRecognitionDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardRecognition/:awardRecognitionId/edit"
                component={AwardRecognitionEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardRecognition/:awardRecognitionId/delete"
                component={AwardRecognitionDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardLevel/create"
                component={AwardLevelCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardLevel/:awardLevelId/details"
                component={AwardLevelDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardLevel/:awardLevelId/edit"
                component={AwardLevelEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardLevel/:awardLevelId/delete"
                component={AwardLevelDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardType/create"
                component={AwardTypeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardType/:awardTypeId/details"
                component={AwardTypeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardType/:awardTypeId/edit"
                component={AwardTypeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/awardType/:awardTypeId/delete"
                component={AwardTypeDeleteComponent}
              />
              {/* Grading BRO route */}
              <Route
                path="/app/grading/bureau/"
                exact={true}
                component={BureauGradingDashboardComponent}
              />
              <Route
                path="/app/grading/bureau/vacancyApplication/:vacancyApplicationId"
                component={BureauGradingComponent}
              />
              {/* Grading CSO route */}
              <Route
                path="/app/grading/educationalCenter/"
                exact={true}
                component={EducationalCenterGradingDashboardComponent}
              />
              <Route
                path="/app/grading/educationalCenter/vacancyApplication/:vacancyApplicationId"
                component={EducationalCenterGradingComponent}
              />
              {/* Grading School route */}
              <Route
                path="/app/grading/school/"
                exact={true}
                component={SchoolGradingDashboardComponent}
              />
              <Route
                path="/app/grading/school/vacancyApplication/:vacancyApplicationId"
                component={SchoolGradingComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleType/create"
                component={ProfessionalTitleTypeCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleType/:titleTypeId/details"
                component={ProfessionalTitleTypeDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleType/:titleTypeId/edit"
                component={ProfessionalTitleTypeEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleType/:titleTypeId/delete"
                component={ProfessionalTitleTypeDeleteComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleArea/create"
                component={ProfessionalTitleAreaCreateComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleArea/:titleAreaId/details"
                component={ProfessionalTitleAreaDetailsComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleArea/:titleAreaId/edit"
                component={ProfessionalTitleAreaEditComponent}
              />
              <Route
                path="/app/configuration/gradingSchema/:gradingSchemaId/edit/professionalTitleArea/:titleAreaId/delete"
                component={ProfessionalTitleAreaDeleteComponent}
              />
            </Route>
          </div>
        </div>
      </div>
    </div>
  );
}
